const styles = (theme) => ({
  dialogContainer: {
    height: '100%',
    width: '100%'
  },
  formContainer:{
    borderRadius: '4px',
    padding: "15px",
    marginRight: 5,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxSizing: 'border-box'
  },
  splitLeftPanel: {
    backgroundColor: theme.gridBGColor
  },
  splitRightPanel: {
    height: '100%',
    backgroundColor: theme.gridBGColor,
    borderRadius: '4px 4px 0 0',
    boxSizing: 'border-box'
  },
  dialog: {
    padding: "19px 23px",
    display: "flex",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    fontWeight: "600",
  },
  dialogWrapper: {},
  dialogContents: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    overflowX: 'hidden',
    overflowY: 'auto',
    flex: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    width:"100%",
    opacity:"0.7",
    height: "0px",
  },
  closeButton: {
    position: "absolute",
    right: 13,
    top: 22,
    color: theme.iconColor,
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    top: "19px",
  },
  selectFilterClass: {
    direction: "column",
    marginTop: 0,
    marginBottom: 0,
    flexGrow: 0,
    width: "160px",
    '&>div': {
      width: "100%"
    }
  },
  resetButton:{
    fontSize: theme.textFontSize,
    color: theme.error,
    float: "right",
    textTransform:"uppercase"
  },
  rightInfoGrid: {
    marginRight: 8,
  },
  greedRoot: {
    flexGrow: 1
  },
  paper: {
    padding: 5,
    textAlign: "left",
  },
  input: {
    color: theme.TextColor,
    height: 43,
    fontSize:12,
  },
  InputLabelProps: {
    color: theme.iconColor,
    transform: 'translate(14px, 13px) scale(1)',
  },
  inputAdornment: {
    color: theme.iconColor
  },
  closedDay: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    paddingBottom: 20,
  },
  closeIcon:{
    '&:hover':{
      color: theme.error
    },
    color: theme.iconColor
  },
  defaultHours: {
    color: theme.ErrorMessageColor
  },
  receivingHours: {
    fontSize: theme.textFontSize,
    fontWeight: "bold",
    paddingBottom: 10,
    paddingTop: 8
  },
  deliveryDetails: {
    fontSize: theme.textFontSize,
    fontWeight: "bold",
  },
  infoOutlinedIconStyle: {
    paddingLeft: 7
  },
  textFieldClass: {
    width: "160px !important",
    color: theme.TextColor,
  },
  disabledDefaultHours:{
    opacity:0.6,
    pointerEvents:"none"
  },
  timeRangeEditorStyle: {
    marginBottom: 10,
    marginLeft:-5
  },
  notchedOutline: {},
  inputRoot: {
    "& $notchedOutline, &:hover":
      {
        borderColor: theme.iconColor,
        borderWidth: 1,
      },
  },
  routeInputContainer: {
    display: "flex"
  },
  tabContainer: {
    color: theme.TextColor,
    width: "100%",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  tabRoot: {
    textTransform: "none",
    fontSize: theme.headerTextFontSize,
    color: theme.disabledColor,
    fontWeight: 600,
    "&$tabSelected": {
      color: theme.HeaderSelectedText,
    },
    "&:hover": {
      color: theme.HeaderSelectedText,
      opacity: 1,
    },
  },
  tabSelected: {},
  routeStopContainer : {
    display: "flex",
    alignItems: "center",
    paddingRight: 20,
    marginBottom: 10,
    gap: "8px"
  },
  paddingBottom:{
    paddingBottom: 8
  },
  checkBoxGroupContainer:{
    gap: "8px",
    marginBottom: 18,
    marginTop: 18
  },
  contactDetailsContainer:{
    paddingBottom: "10px"
  },
  contactDetailsSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
  },
  contactNameContainer: {
    maxWidth: "230px",
    width:"100%"
  },
  deliveryReceiptContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '-8px',
  },
});

export default styles;
